import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { io, Socket } from "socket.io-client";
import { environment } from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AdminTicketSocketService {

  private socket!: Socket;
  private baseURL = `${environment.apiUrl.replace('v1/', '')}`
  private URL = `${this.baseURL}tickets`; // Your backend URL
  adminNewTicket = new BehaviorSubject<any>({});
  newReply = new BehaviorSubject<any>({});

  constructor() {

    this.initAdminSocket();

  }
  initAdminSocket() {
    this.socket = io(`${this.URL}`, {
      transports: ['websocket']
    })
    this.onConnectAdminSocket();
  }

  onConnectAdminSocket() {
    if (this.socket) this.socket.on('connect', () => {
      this.joinToAdminRoom();
    })
  }

  joinToAdminRoom() {
    if (this.socket) this.socket.emit('joinAdminRoom');
    this.onChangeTicketsInAdmin();
    this.onNewMessage();
  }

  onChangeTicketsInAdmin() {
    if (this.socket) this.socket.on('newTicket', data => {
      this.adminNewTicket.next(data);
    })
  }
  onNewMessage() {
    // console.log('this.socket: ', !!this.socket);
    if (this.socket) this.socket.on('ticketReply', data => {

      this.newReply.next(data);
    })
  }
}
